import {postWithAuth} from '@/api'

export const getSession = () =>
    postWithAuth<{expiresIn: number; sessionId: string}>('/oauth/oauth2/sessions')

export const createSession = () => postWithAuth('/oppapi/v1/digital-receipts/interest-requests')
